import styled from "styled-components";

export const HeaderPicture = styled.div`
  width: 100%;
  height: 168px;
  border-radius: 4px 4px 0 0;
  background: url(${props => props.theme[props.eventType.toLowerCase()]})
    no-repeat center;
  background-size: cover;
`;

export const MarkdownContainer = styled.div`
  width: 100%;
  background: ${props => props.theme.specialPopupBackgroundColor};
  padding: 30px 22px 24px;

  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 28px;
    padding-bottom: 16px;
  }

  p {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
  }

  ${props => !props.removeMarkdownBorderRadius && "border-radius: 0 0 4px 4px"}
`;
